import { metaAccount } from '@/router/meta-config'
const permissionKey = 'PAGE'

export default [
  {
    path: '/historical-figures',
    name: 'page-historical-figures',
    component: () => import('@/pages/historicalFigures'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/historical-figure/new',
    name: 'page-historical-figure-new',
    component: () => import('@/pages/historicalFigure'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/historical-figure/:id',
    name: 'page-historical-figure',
    component: () => import('@/pages/historicalFigure'),
    props: (route) => ({ id: Number(route.params.id) }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
